module.exports = __webpack_public_path__ + "img/default-avatar.02659d35.svg";